import { Component, OnInit } from '@angular/core';
import { Login } from './user.types';
import { AuthService } from './auth.service';
import { Router } from '@angular/router';

@Component({
  template: `
    <b4a-login-form [login]="login" [errors]="errors"  [onSubmit]="onSubmit.bind(this)"></b4a-login-form>
  `
})
export class LoginPageComponent implements OnInit {

  login: Login;

  errors: [string];

  constructor(
    private authService: AuthService,
    private router: Router,
  ) {}

  ngOnInit() {
    this.login = {
      tenant: '',
      username: '',
      password: ''
    };
  }

  routeToWelcome() {
    this.router.navigate(['welcome'])
  }

  onSubmit() {
    this.authService
      .login(this.login)
      .subscribe((success) => {
        if (success) {
          localStorage.setItem('loggedIn', 'true');
          let url =  localStorage.getItem('redirectURL');

          let urlArray = url.split('/')
          let test
          if (urlArray[urlArray.length - 1] !== '') { // if urlArray[urlArray.length - 1] is '' it would be 0 after converting to Number and wont go into else so it must be checked
             test = Number(urlArray[urlArray.length - 1])
          }
          if (!isNaN(test)) {
            let redirectUrl = '/' + urlArray[urlArray.length - 3] + '/' +  urlArray[urlArray.length - 2] + '/' + urlArray[urlArray.length - 1]
               setTimeout(() => {
              this.router.navigate([redirectUrl])
            }, 1000);
          }else {
               setTimeout(() => {
              this.router.navigate(['products/simpleTravels'])
            }, 1000);
          }
        }
      }, (error) => {
        // const body = error.json();
        // this.errors = body && body.errors ? body.errors.map(err => err.description) : null;
        this.errors = ['Anmeldung fehlgeschlagen'];
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/users/login-page.container.ts